import type { Language } from "@app/constants";

interface Messages {
	header: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		header: "Viewing file: ",
	},
};

export default messages;
